'use-strict';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './style.css';
import 'moment';
import m from 'mithril';
import 'sweetalert';
import 'signature_pad';
import '@pub/css/bs-flex.css'
import '@pub/css/bs-paddings-margins.css'

import { setCurrentDateTime } from '@/utils.js';
import { runCurrentTimeTimer } from '@/components/TimerControl.js';
import { user } from '@/components/User.js'
import { storage } from '@/components/Storage.js';
import { MessagePage } from "./js/Pages/MessagePage";
import { TaskFlightPhotoPage } from "./js/Pages/TaskFlightPhotoPage";
import { TaskFlightGalleryPage } from "./js/Pages/TaskFlightGalleryPage";
import { FinalAccountingCardPage } from "./js/Pages/FinalAccountingCardPage";
import { TaskWorksPage } from "./js/Pages/TaskWorksPage";
import { TaskFlightDataPage } from "./js/Pages/TaskFlightDataPage";
import { flightOperationPage } from "@/Pages/FlightOperationPage";
import { flightSchedulePage } from "@/Pages/FlightSchedulePage";
import { FlightServicesPage } from "./js/Pages/FlightServicesPage";
import { ReorderingPage } from "./js/Pages/ReorderingPage";
import { BoardCenteringPage } from "./js/Pages/BoardCenteringPage";
import { ProfilePage } from "./js/Pages/ProfilePage";
import { LoginPage } from "./js/Pages/LoginPage";
import { LogoutPage } from "./js/Pages/LoginPage";
import { StaffOnFlightPage } from "./js/Pages/StaffOnFlight";
import { closeAudioRecord } from "./js/functions";
import { LoadsheetPage } from "./js/Pages/LoadsheetPage";
import { LoadsheetLmcPage } from "./js/Pages/LoadsheetLmcPage";
import { runAppNotificationTimer } from '@/components/AppNotification.js';
import { runAjaxLoaderTimer } from '@/components/AjaxLoaderTimer.js';
import { SelectWorkplacePage } from "./js/Pages/SelectWorkplacePage";
import { SelectConveyerPage } from "./js/Pages/SelectConveyerPage";
import { ConveyerFlightsPage } from "./js/Pages/ConveyerFlightsPage";
import { ConveyerFlightsTimePage } from "./js/Pages/ConveyerFlightsTimePage";
import { SelectVehiclePage } from "./js/Pages/SelectVehiclePage";
import { VehicleTasksPage } from "./js/Pages/VehicleTasksPage";
import { VehicleFreeTasksPage } from "./js/Pages/VehicleFreeTasksPage";
import { isEnabledMsg } from "@/utils.js";
import { UserTasksPage } from './js/Pages/UserTasksPage';
import { AgentTasksPage }from './js/Pages/AgentTasksPage';
import { SecurityFlightsPage } from './js/Pages/SecurityFlightsPage';
import { AgentFlightsPage } from './js/Pages/AgentFlightsPage';
import { TaskFlightInfoPage } from './js/Pages/TaskFlightInfoPage';
import { FlightInfoPage } from './js/Pages/FlightInfoPage';
import { taskFlightCheckListPage } from './js/Pages/TaskFlightCheckListPage';
import { checkMessage } from "@/utils";
import { geolocation } from '@/utils';
import { record_audio } from '@/utils';

storage.online = false;
runAjaxLoaderTimer();
runAppNotificationTimer();

m.request({
    method: 'GET',
    url: '/api/current-time',
}).then(function (response) {
    setCurrentDateTime(response.currentTime);
}, function (err) {
    // current-time работает без аутентификации, поэтому нет вариантов 401, 403
})

runCurrentTimeTimer()

document.addEventListener("visibilitychange", () => {
    m.request({
        method: 'GET',
        url: '/api/current-time',
        extract(xhr) {
            const statusErr = [401, 403]
            const obj = xhr.response
            return statusErr.includes(xhr.status) ? xhr.status : xhr.response;
        }
    }).then(function (response) {
        setCurrentDateTime(response.currentTime);
    }, function (err) {
        if ([401, 403].includes(err)) {
            user.destroy()
            if (m.route() !== '/login') {
                window.location.replace('/login')
            }
        }
    });
});


if (user.exists() && isEnabledMsg()) {
    const config = storage.config;
    if(config) {
        if(config["message_service"] !== 'undefined' && config["message_turn"]) {
            const messageTimerID = localStorage.getItem("msgTimerID");
            if(messageTimerID == null) {
                checkMessage(config["message_service"]);
                const idTimer = setInterval(() => checkMessage(config["message_service"]), 10000);
                localStorage.setItem("msgTimerID", idTimer);
            }
            else {
                clearInterval(messageTimerID);
                checkMessage(config["message_service"]);
                const idTimer = setInterval(() => checkMessage(config["message_service"]), 10000);
                localStorage.setItem("msgTimerID", idTimer);
            }
        }
    }
}

/************************************************************************* */

m.route.mode = 'pathname';
m.route(document.querySelector('.app'), '/', {
    '/': UserTasksPage,
    '/login': LoginPage,
    '/logout': LogoutPage,
    '/profile': ProfilePage,
    '/workplace': SelectWorkplacePage,
    '/vehicle': SelectVehiclePage,
    '/conveyer': SelectConveyerPage,
    '/conveyer/flights': ConveyerFlightsPage,
    '/conveyer/flights/:flightId/time': ConveyerFlightsTimePage,
    '/vehicle/tasks': VehicleTasksPage,
    '/vehicle/tasks/free': VehicleFreeTasksPage,
    '/security/flights': SecurityFlightsPage,
    '/agent/tasks': AgentTasksPage,
    '/agent/flights': AgentFlightsPage,
    '/flight/:flightId/info': FlightInfoPage,
    '/task/:taskId/works': TaskWorksPage,
    '/task/:taskId/data': TaskFlightDataPage,
    '/task/:taskId/operation': flightOperationPage,
    '/task/:taskId/info': TaskFlightInfoPage,
    '/task/:taskId/schedule': flightSchedulePage,
    '/task/:taskId/services': FlightServicesPage,
    '/task/:taskId/reordering': ReorderingPage,
    '/task/:taskId/centering': BoardCenteringPage,
    '/task/:taskId/photo': TaskFlightPhotoPage,
    '/task/:taskId/gallery': TaskFlightGalleryPage,
    '/task/:taskId/checklist': taskFlightCheckListPage,
    '/task/:taskId/accounting': FinalAccountingCardPage,
    '/task/:taskId/accounting/tgo': FinalAccountingCardPage,
    '/message': MessagePage,
    '/task/:taskId/staff': StaffOnFlightPage,
    '/task/:taskId/loadsheet': LoadsheetPage,
    '/task/:taskId/loadsheet/lmc': LoadsheetLmcPage,
});

geolocation();
setInterval(() => geolocation(), 30000);

record_audio();

window.onload = function() {
    closeAudioRecord();
};

addEventListener("popstate",function(e){
    closeAudioRecord();
},false);
